import { flow, get, replace } from 'lodash/fp';

export default (fullUrl, size) =>
  fullUrl ? flow(replace('{size}', size))(fullUrl) : undefined;

export const getMainImage = get(['overviewImage', 'url']);
